export const DEFAULT_INVITATIONS_ROWS_PER_PAGE = 10;
export const SEVEN_ROWS_PER_PAGE = 7;
